/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';

var FormContext = /*#__PURE__*/React.createContext({
  form: void 0,
  labelWidth: "100px",
  labelAlign: "right",
  layout: "vertical",
  colon: false,
  initialData: {},
  requiredMark: void 0,
  scrollToFirstError: void 0,
  showErrorMessage: void 0,
  resetType: "empty",
  disabled: void 0,
  rules: void 0,
  errorMessage: void 0,
  statusIcon: void 0,
  onFormItemValueChange: void 0,
  formMapRef: void 0
});
var useFormContext = function useFormContext() {
  return React.useContext(FormContext);
};
var FormListContext = /*#__PURE__*/React.createContext({
  name: void 0,
  rules: void 0,
  formListMapRef: void 0
});
var useFormListContext = function useFormListContext() {
  return React.useContext(FormListContext);
};

export { FormListContext, FormContext as default, useFormContext, useFormListContext };
//# sourceMappingURL=FormContext.js.map
